import React from 'react';
import { Result, Typography, Flex } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import QueueAnim from 'rc-queue-anim';

const { Title, Paragraph } = Typography;

const InvalidRestaurantTokenPage = () => {
    return (
        <QueueAnim
            delay={300}
            duration={1000}
            animConfig={[
                { opacity: [1, 0], translateY: [0, 50] },
                { opacity: [1, 0], translateY: [0, -50] },
            ]}
        >
            <Flex vertical align='center' justify='center' key="1" style={{ padding: '20px', width: "100vw", height: "100vh", background: "#fbd3c1", overflow: 'hidden', }}>
                <Title
                    level={2}
                    style={{
                        fontFamily: 'var(--headline-h2-font-family)',
                        fontSize: 'var(--headline-h2-font-size)',
                        fontWeight: 'var(--headline-h2-font-weight)',
                        letterSpacing: 'var(--headline-h2-letter-spacing)',
                        lineHeight: 'var(--headline-h2-line-height)',
                        color: 'var(--base-colorbase-color-01)',
                        marginBottom: '20px',
                    }}
                >
                    Token de restaurante inválido
                </Title>
                <Result
                    status="error"
                    icon={<ExclamationCircleOutlined style={{ fontSize: 48, color: 'var(--error-colorerror-color-01)' }} />}
                />
                <Paragraph
                    style={{
                        fontFamily: 'var(--body-body-3-font-family)',
                        fontSize: 'var(--body-body-3-font-size)',
                        fontWeight: 'var(--body-body-3-font-weight)',
                        letterSpacing: 'var(--body-body-3-letter-spacing)',
                        lineHeight: 'var(--body-body-3-line-height)',
                        color: 'var(--neutral-colorneutral-02-color-01)',
                        marginTop: '20px',
                    }}
                >
                    O token do restaurante inserido é inválido. Por favor, verifique e tente novamente. Adicione ou peça um novo token.
                </Paragraph>
            </Flex>
        </QueueAnim>
    );
};

export default InvalidRestaurantTokenPage;
